import React from "react";
export const alif_logo = (
  <svg
    width="53"
    height="53"
    viewBox="0 0 53 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    
    <path
      d="M29.169 12.8269H22.299L13.1359 35.3786H19.014L25.734 17.9602L32.4539 35.3786H38.3321L29.169 12.8269Z"
      fill="#39B980"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.2506 51.9516L23.203 51.9461H23.192L23.1884 51.9443C19.7351 51.5984 16.4135 50.5534 13.4159 48.9155C7.62925 45.755 3.04862 40.3911 1.04837 33.5724C-0.953711 26.7517 -0.00025195 19.7664 3.15842 13.9834C4.78351 11.0059 6.99422 8.34871 9.6844 6.19657L9.73747 6.15264C9.7393 6.15081 9.74113 6.14898 9.74296 6.14715C13.727 2.88234 18.6023 0.708231 23.8856 0.0237907C23.9131 0.0201306 24.0869 0.00366011 24.1144 0L26.3288 5.45173C26.2976 5.45356 26.1165 5.47003 26.0854 5.47186C21.373 5.76467 17.001 7.53617 13.4854 10.3636C13.4305 10.4075 13.3738 10.4533 13.3189 10.4972C13.231 10.5704 13.1432 10.6418 13.0572 10.7168L13.0517 10.7205L13.0444 10.726L13.0371 10.7333L13.0316 10.7369C13.0096 10.7571 12.9858 10.7754 12.9639 10.7937C10.9673 12.4371 9.32388 14.4428 8.10323 16.6755C5.63632 21.192 4.89332 26.6529 6.45618 31.982C8.02271 37.3148 11.595 41.5056 16.1079 43.9707C18.4998 45.2756 21.1552 46.0991 23.9167 46.3535C29.9285 46.8476 35.5943 44.9132 39.9297 41.3592C40.1402 41.1872 40.3488 41.0097 40.5519 40.8304L42.7718 46.2912C37.3896 50.4125 30.5123 52.6031 23.2506 51.9516Z"
      fill="#39B980"
    />
  </svg>
);
export const helpicon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#A6ABB0"
      strokeWidth="2"
    />
    <path
      d="M12.4273 7.03874L12.2582 8.02434L12.4273 7.03874ZM14.9201 10L13.9201 9.99853V10H14.9201ZM12.584 12.7225L13.016 13.6243L12.584 12.7225ZM12.2582 8.02434C12.7238 8.10419 13.146 8.34622 13.4502 8.70755L14.9802 7.41955C14.3719 6.69688 13.5274 6.21283 12.5963 6.05313L12.2582 8.02434ZM13.4502 8.70755C13.7543 9.06889 13.9208 9.52622 13.9201 9.99853L15.9201 10.0015C15.9215 9.05688 15.5886 8.14222 14.9802 7.41955L13.4502 8.70755ZM13.9201 10C13.9201 10.3211 13.7568 10.6524 13.3916 11.0023C13.0264 11.3522 12.5484 11.6307 12.1519 11.8206L13.016 13.6243C13.5032 13.3909 14.1932 13.004 14.7752 12.4464C15.3572 11.8889 15.9201 11.0706 15.9201 10H13.9201ZM10.9201 13.7208V14.5362H12.9201V13.7208H10.9201ZM9.64202 9.96316C9.967 8.69019 11.1321 7.83119 12.2582 8.02434L12.5963 6.05313C10.2058 5.64309 8.22297 7.43629 7.70417 9.46844L9.64202 9.96316ZM12.1519 11.8206C11.4687 12.1479 10.9201 12.851 10.9201 13.7208H12.9201C12.9201 13.7206 12.92 13.7192 12.9213 13.7154C12.9226 13.7113 12.9258 13.7033 12.9331 13.6926C12.9488 13.6696 12.9771 13.643 13.016 13.6243L12.1519 11.8206Z"
      fill="#A6ABB0"
    />
    <path
      d="M12 17H12.01"
      stroke="#A6ABB0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const aliflogo = (
  <svg
    width="98"
    height="36"
    viewBox="0 0 98 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M46.7086 17.4088C46.7086 18.4671 46.3382 19.3667 45.6503 20.1075C44.9625 20.8483 43.9042 21.2186 42.8459 21.2186C41.7876 21.2186 40.8881 20.8483 40.2002 20.1075C39.5652 19.3667 39.1948 18.4671 39.1948 17.4088C39.1948 16.3505 39.5652 15.451 40.2002 14.7102C40.8881 13.9694 41.7876 13.599 42.8459 13.599C43.9042 13.599 45.0154 13.9694 45.7033 14.7102C46.3911 15.451 46.7086 16.3505 46.7086 17.4088ZM46.6557 12.3291C45.5445 11.3766 44.1687 10.9004 42.5813 10.9004C40.8352 10.9004 39.1419 11.5354 37.9249 12.7524C36.7608 13.9694 36.1787 15.5568 36.1787 17.4088C36.1787 19.2608 36.7608 20.8482 37.9249 22.1182C39.089 23.3881 40.7822 23.9702 42.5813 23.9702C44.2217 23.9702 45.4387 23.494 46.6557 22.5415V23.7056H49.5131V11.165H46.6557V12.3291Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.1588 23.8639C53.6404 23.8639 54.8045 23.229 55.5982 22.0119C55.9157 21.5357 56.1803 20.7949 56.3919 20.3187C56.6036 19.7896 56.8153 18.7842 56.9211 18.308C56.974 18.0963 57.0798 17.7259 57.1327 17.1968L57.2915 16.1385C57.2915 15.9268 57.3973 15.5564 57.4502 14.9744L57.609 13.9161H60.4134V23.7052H63.3766V11.1646H55.0162L54.9104 12.0641C54.6458 14.4452 54.4341 16.2972 54.1696 17.6201C53.9579 18.89 53.5875 19.8954 53.1113 20.5833C52.635 21.2182 52.053 21.5357 51.2593 21.5357L51.418 23.7581C51.7355 23.811 52.0001 23.8639 52.1588 23.8639Z"
      fill="black"
    />
    <path
      d="M90.0454 13.493C92.9027 13.493 94.596 15.0275 94.596 17.4086C94.596 19.8427 92.8498 21.3772 90.0454 21.3772V13.493ZM82.6374 17.4086C82.6374 14.9746 84.3306 13.493 87.188 13.493V21.3772C84.3836 21.3243 82.6374 19.8956 82.6374 17.4086ZM97.5063 17.4086C97.5063 15.4508 96.8184 13.8634 95.4426 12.6993C94.0668 11.5351 92.2678 10.9002 90.0454 10.8473V7.51367H87.188V10.8473C84.9127 10.9002 83.1136 11.5351 81.7908 12.6993C80.415 13.8634 79.78 15.4508 79.78 17.4086C79.78 19.3664 80.415 20.901 81.7908 22.0651C83.1665 23.2292 84.9656 23.8112 87.188 23.9171V27.2506H90.0454V23.9171C92.3207 23.8641 94.1198 23.2292 95.4426 22.0651C96.8184 20.9539 97.5063 19.4194 97.5063 17.4086Z"
      fill="black"
    />
    <path
      d="M67.7684 23.6523L74.806 15.8739V23.6523H77.6634V11.1646H75.8114L68.7738 19.0488V11.1646H65.8635V23.6523H67.7684Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1206 35.9201C13.6905 35.6922 11.4122 35.0088 9.28588 33.8697C5.26101 31.6674 2.14743 27.9463 0.704556 23.2379C-0.662381 18.5296 0.0210872 13.6694 2.22337 9.72044C5.10913 4.40457 10.6528 0.759409 16.5762 0H16.7281L18.2469 3.79705C18.171 3.79705 18.095 3.79705 18.095 3.79705C13.0829 4.10081 8.07083 7.06251 5.64072 11.543C3.89407 14.6566 3.43843 18.4536 4.5016 22.0988C5.56477 25.8199 8.07083 28.7057 11.1844 30.3764C12.8551 31.2877 14.6777 31.8192 16.5762 32.0471C20.753 32.4268 24.6259 31.0598 27.6636 28.6297C27.8155 28.4778 27.9673 28.4019 28.1192 28.25L29.638 32.0471C25.9169 34.8569 21.1327 36.3757 16.1206 35.9201ZM20.2214 8.88509H15.4371L9.134 24.453H13.2348L17.8672 12.3784L22.4996 24.453H26.6004L20.2214 8.88509Z"
      fill="#39B980"
    />
  </svg>
);
export const downarrow = (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.5 1L6 5.5L1.5 1" stroke="#73787D" strokeWidth="1.5" />
  </svg>
);
export const likeSVG = (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M58.5287 32.7998V13.3538C58.5287 9.48575 56.9871 5.77612 54.243 3.041C51.499 0.305867 47.7772 -1.23071 43.8965 -1.23071L24.387 42.5229V95.9994H79.404C81.7565 96.0259 84.0393 95.2041 85.8319 93.6854C87.6245 92.1666 88.806 90.0534 89.1587 87.7349L95.8895 43.9813C96.1017 42.5878 96.0075 41.1649 95.6132 39.8114C95.2189 38.4578 94.5341 37.2058 93.6062 36.1422C92.6783 35.0786 91.5295 34.2288 90.2394 33.6517C88.9493 33.0745 87.5488 32.7839 86.1348 32.7998H58.5287ZM24.387 95.9994H9.75479C7.16766 95.9994 4.68649 94.975 2.85711 93.1516C1.02773 91.3282 0 88.8551 0 86.2764V52.2459C0 49.6672 1.02773 47.1941 2.85711 45.3707C4.68649 43.5472 7.16766 42.5229 9.75479 42.5229H24.387"
      fill="#E9EEF3"
    />
    <path
      d="M24 96.0001H9.6C7.05392 96.0001 4.61212 94.962 2.81177 93.1141C1.01143 91.2662 0 88.7599 0 86.1466V51.6594C0 49.0461 1.01143 46.5398 2.81177 44.6919C4.61212 42.844 7.05392 41.8059 9.6 41.8059H24"
      fill="#39B980"
    />
  </svg>
);
export const upAccordionArrowSVG = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.8492 9.84924L11 19.6985L1.15076 9.84924"
      stroke="#DFE4E9"
      strokeWidth="2"
    />
  </svg>
);
export const downAccordionArrowSVG = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.8492 11.8492L11 2L1.15076 11.8492"
      stroke="#39B980"
      strokeWidth="2"
    />
  </svg>
);

export const playPauseSVG = (
  <svg
    width="170"
    height="170"
    viewBox="0 0 170 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84.9994 155.697C124.009 155.697 155.632 124.123 155.632 85.1753C155.632 46.2275 124.009 14.654 84.9994 14.654C45.9899 14.654 14.3665 46.2275 14.3665 85.1753C14.3665 124.123 45.9899 155.697 84.9994 155.697Z"
      stroke="#A6ABB0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.873 60.7007C70.873 59.104 72.652 58.1511 73.9812 59.0358L110.751 83.5106C111.941 84.3021 111.941 86.049 110.751 86.8404L73.9812 111.315C72.652 112.2 70.873 111.247 70.873 109.65V60.7007Z"
      fill="#A6ABB0"
    />
  </svg>
);
export const trashIconSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6H21"
      stroke="#A6ABB0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
      stroke="#A6ABB0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 11V17"
      stroke="#A6ABB0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 11V17"
      stroke="#A6ABB0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const cancelButtonSVG = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="#A6ABB0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="#A6ABB0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const modalError = (
  <svg
    width="100"
    height="101"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 92.5C73.196 92.5 92 73.696 92 50.5C92 27.304 73.196 8.5 50 8.5C26.804 8.5 8 27.304 8 50.5C8 73.696 26.804 92.5 50 92.5ZM50 100.5C77.6142 100.5 100 78.1142 100 50.5C100 22.8858 77.6142 0.5 50 0.5C22.3858 0.5 0 22.8858 0 50.5C0 78.1142 22.3858 100.5 50 100.5ZM50.0002 44.8431L63.8384 31.0048L69.4953 36.6617L55.657 50.4999L69.4953 64.3382L63.8384 69.995L50.0002 56.1568L36.1619 69.995L30.5051 64.3382L44.3433 50.4999L30.5051 36.6617L36.1619 31.0048L50.0002 44.8431Z"
      fill="#FF4444"
    />
  </svg>
);
export const modalInfo = (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 92C73.196 92 92 73.196 92 50C92 26.804 73.196 8 50 8C26.804 8 8 26.804 8 50C8 73.196 26.804 92 50 92ZM50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100ZM46 59V22H54V59H46ZM46 67V76H54V67H46Z"
      fill="#39B980"
    />
  </svg>
);
export const clearInput = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="14" cy="14" r="14" fill="#DFE4E9" />
    <path
      d="M9.00098 9L19.001 19M9.00098 19L19.001 9"
      stroke="#39B980"
      strokeWidth="1.6"
    />
  </svg>
);
export const union = (
  <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.75329 2 2.5 6.25329 2.5 11.5C2.5 16.7467 6.75329 21 12 21C17.2467 21 21.5 16.7467 21.5 11.5C21.5 6.25329 17.2467 2 12 2ZM0.5 11.5C0.5 5.14873 5.64873 0 12 0C18.3513 0 23.5 5.14873 23.5 11.5C23.5 17.8513 18.3513 23 12 23C5.64873 23 0.5 17.8513 0.5 11.5ZM11 12V5.5H13V12H11ZM11 14.5V16.5H13V14.5H11Z" fill="#ff4d4d" />
  </svg>

);
export const backPassportNew = (
  <svg
    width="94"
    height="60"
    viewBox="0 0 94 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="93"
      height="59"
      rx="3.5"
      fill="#F7F8F9"
      stroke="#DFE4E9"
    />
    <rect
      x="44.4365"
      y="19"
      width="40.1636"
      height="4.28572"
      rx="2.14286"
      fill="#DFE4E9"
    />
    <rect
      x="44.4365"
      y="10.2856"
      width="40.1636"
      height="4.28571"
      rx="2.14286"
      fill="#DFE4E9"
    />
    <rect
      x="12.8184"
      y="10.2856"
      width="16.2364"
      height="8.57143"
      rx="4"
      fill="#DFE4E9"
    />
    <rect x="10" y="38" width="75" height="4" rx="2" fill="#DFE4E9" />
    <rect x="10" y="47" width="63" height="4" rx="2" fill="#DFE4E9" />
  </svg>
);
export const documentIcon = (
  <svg
    width="94"
    height="60"
    viewBox="0 0 94 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="23.5"
      y="0.5"
      width="47"
      height="59"
      rx="3.5"
      fill="#F7F8F9"
      stroke="#DFE4E9"
    />
    <rect x="29" y="35" width="37" height="4" rx="2" fill="#DFE4E9" />
    <rect x="29" y="45" width="16" height="4" rx="2" fill="#DFE4E9" />
    <rect x="49" y="9" width="16" height="4" rx="2" fill="#DFE4E9" />
    <rect x="29" y="26" width="37" height="4" rx="2" fill="#DFE4E9" />
    <rect x="29" y="6" width="11" height="11" rx="5.5" fill="#DFE4E9" />
    <rect x="53" y="43" width="7" height="7" rx="3.5" fill="#DFE4E9" />
  </svg>
);

export const frontPassportNew = (
  <svg
    width="94"
    height="60"
    viewBox="0 0 94 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="93"
      height="59"
      rx="3.5"
      fill="#F7F8F9"
      stroke="#DFE4E9"
    />
    <ellipse cx="22.6454" cy="31.7144" rx="6.40909" ry="6" fill="#DFE4E9" />
    <path
      d="M35.8913 52.2858C35.8913 48.8759 34.4958 45.6057 32.0118 43.1945C29.5278 40.7833 26.1588 39.4287 22.6458 39.4287C19.1329 39.4287 15.7639 40.7833 13.2799 43.1945C10.7959 45.6057 9.40039 48.8759 9.40039 52.2858L35.8913 52.2858Z"
      fill="#DFE4E9"
    />
    <rect
      x="44.4365"
      y="28.2856"
      width="40.1636"
      height="4.28572"
      rx="2.14286"
      fill="#DFE4E9"
    />
    <rect
      x="44.4365"
      y="10.2856"
      width="40.1636"
      height="4.28571"
      rx="2.14286"
      fill="#DFE4E9"
    />
    <rect
      x="12.8184"
      y="10.2856"
      width="16.2364"
      height="8.57143"
      rx="4"
      fill="#DFE4E9"
    />
    <rect
      x="44.4365"
      y="37.7144"
      width="40.1636"
      height="4.28571"
      rx="2.14286"
      fill="#DFE4E9"
    />
    <rect
      x="44.4365"
      y="47.1431"
      width="34.1818"
      height="4.28572"
      rx="2.14286"
      fill="#DFE4E9"
    />
  </svg>
);
export const frontPassportOld = (
  <svg width="116" height="74" viewBox="0 0 116 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="28.8829" y="0.5" width="58.234" height="73" rx="3.5" fill="#F7F8F9" stroke="#DFE4E9" />
    <rect x="28.8829" y="0.5" width="58.234" height="73" rx="3.5" fill="#F7F8F9" stroke="#DFE4E9" />
    <rect x="51.8298" y="43.1667" width="29.617" height="4.93333" rx="2.46667" fill="#DFE4E9" />
    <rect x="43.1915" y="7.4" width="39.4894" height="4.93333" rx="2.46667" fill="#DFE4E9" />
    <rect x="51.8298" y="53.0333" width="22.2128" height="4.93333" rx="2.46667" fill="#DFE4E9" />
    <rect x="43.1915" y="24.6667" width="29.617" height="4.93333" rx="2.46667" fill="#DFE4E9" />
    <rect x="51.8298" y="62.9" width="28.383" height="4.93333" rx="2.46667" fill="#DFE4E9" />
    <rect x="43.1915" y="16.0333" width="38.2553" height="4.93333" rx="2.46667" fill="#DFE4E9" />
    <ellipse cx="40.7234" cy="56.7333" rx="3.70213" ry="3.7" fill="#DFE4E9" />
    <path d="M48.1276 69.0667C48.1276 67.1041 47.3475 65.2218 45.9589 63.8341C44.5704 62.4463 42.6871 61.6667 40.7233 61.6667C38.7596 61.6667 36.8763 62.4463 35.4877 63.8341C34.0992 65.2218 33.3191 67.1041 33.3191 69.0667L48.1276 69.0667Z" fill="#DFE4E9" />
    <rect x="33.3191" y="37" width="49.3617" height="1.23333" rx="0.616667" fill="#DFE4E9" />
  </svg>

);
export const backPassportOld = (
  <svg width="116" height="74" viewBox="0 0 116 74" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="28.8829" y="0.5" width="58.234" height="73" rx="3.5" fill="#F7F8F9" stroke="#DFE4E9"/>
<rect x="28.8829" y="0.5" width="58.234" height="73" rx="3.5" fill="#F7F8F9" stroke="#DFE4E9"/>
<rect x="37.0212" y="29.6" width="19.7333" height="4.93617" rx="2.46809" transform="rotate(-90 37.0212 29.6)" fill="#DFE4E9"/>
<rect x="44.4255" y="29.6" width="14.8" height="4.93617" rx="2.46809" transform="rotate(-90 44.4255 29.6)" fill="#DFE4E9"/>
<rect x="33.8191" y="6.66666" width="22.4468" height="26.1333" rx="3.5" stroke="#DFE4E9"/>
<rect x="33.3191" y="37" width="49.3617" height="1.23333" rx="0.616667" fill="#DFE4E9"/>
</svg>

);
export const innIcon = (
  <svg
    width="94"
    height="60"
    viewBox="0 0 94 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="23.5"
      y="0.5"
      width="47"
      height="59"
      rx="3.5"
      fill="#F7F8F9"
      stroke="#DFE4E9"
    />
    <rect x="29" y="45" width="16" height="4" rx="2" fill="#DFE4E9" />
    <rect x="39" y="24" width="16" height="4" rx="2" fill="#DFE4E9" />
    <rect x="29" y="33" width="37" height="4" rx="2" fill="#DFE4E9" />
    <rect x="42" y="6" width="11" height="11" rx="5.5" fill="#DFE4E9" />
    <rect x="53" y="43" width="7" height="7" rx="3.5" fill="#DFE4E9" />
  </svg>
);
export const successButtonSVG = (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 1L6 12L1 7" stroke="#39B980" strokeWidth="2" />
  </svg>
);
export const _ = (
  <svg
    width="8"
    height="3"
    viewBox="0 0 8 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="8" height="2" fill="#39B980" />
  </svg>
);
export const doneIcon = (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 92C73.196 92 92 73.196 92 50C92 26.804 73.196 8 50 8C26.804 8 8 26.804 8 50C8 73.196 26.804 92 50 92ZM50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
      fill="#39B980"
    />
    <path d="M70 35L42.5 62.5L30 50" stroke="#39B980" strokeWidth="8" />
  </svg>
);
